import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { take } from 'rxjs/operators';
import { ApiError, ConfigService, MessageService } from '../../../../../core';
import { CanalVenda } from '../../domain';

@Component({
    selector: 'sgt-canal-venda-select',
    templateUrl: './canal-venda-select.component.html',
    styleUrls: ['./canal-venda-select.component.less']
})
export class CanalVendaSelectComponent implements OnInit, OnChanges {
    /** Canais de vendas disponíveis para seleção */
    options: CanalVenda[] = CanalVenda.getAll();

    /** Canal */
    @Input() idCanalVenda: number;
    /** Ao alterar o canal de venda */
    @Output() idCanalVendaChange = new EventEmitter<number>();
    /** Canal de venda selecionado */
    @Input() canalVenda: CanalVenda;
    /** Canal de venda alterado */
    @Output() canalVendaChange = new EventEmitter<CanalVenda>();

    /** Se deve desabilitar o input */
    @Input() disabled: boolean;
    /** Se se o canal é obrigatório */
    @Input() required = false;

    /** Se o component está válido */
    private _isValid: boolean;

    @ViewChild('dropdownToggle') dropdownToggle: ElementRef;

    ngOnInit(): void {
        this.canalVenda = this.getCanalVenda(this.idCanalVenda);
        this.setIsValid();
    }

    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            if (propName === 'idCanalVenda' && !changes[propName].isFirstChange()) {
                this.canalVenda = this.getCanalVenda(this.idCanalVenda);
                this.setIsValid();
            } else if (propName === 'required' && !changes[propName].isFirstChange()) {
                this.setIsValid();
            }
        }
    }

    /** Obtem o canal de venda através do ID */
    private getCanalVenda(idCanalVenda: number): CanalVenda {
        if (!idCanalVenda || !this.options) {
            return null;
        }
        return this.options.find(canalFilter => canalFilter.id === idCanalVenda);
    }

    /** Ao selecionar o canal */
    select(canalVenda: CanalVenda) {
        this.idCanalVenda = canalVenda ? canalVenda.id : null;
        this.idCanalVendaChange.emit(this.idCanalVenda);
        this.canalVenda = canalVenda;
        this.canalVendaChange.emit(this.canalVenda);
        this.setIsValid();
    }

    private setIsValid() {
        // Obrigatório e não selecionada o canal
        if (this.required && !this.idCanalVenda) {
            this._isValid = false;
            return;
        }

        this._isValid = true;
    }

    get isValid(): boolean {
        return this._isValid;
    }

    /** Seta foco no select */
    setFocus() {
        jQuery(this.dropdownToggle?.nativeElement).trigger('focus');
    }
}
